<!--START SERVICES-->
<section class="section pt-5" id="services">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <h1 class="section-title text-center">Our Services</h1>
        <div class="section-title-border mt-3"></div>
        <!--<p class="section-subtitle text-muted text-center pt-4 font-secondary">We craft digital, graphic
          and dimensional thinking, to create category leading brand experiences that have meaning and add a value
          for our clients.</p>-->
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-lg-4 mt-3">
        <div class="services-box text-center hover-effect">
          <i class="pe-7s-diamond text-primary"></i>
          <h4 class="pt-3">TOKENOMICS CONSTRUCTOR</h4>
          <ul class="pt-3 text-muted li_align">
            <li><b>Creation of token economy model</b></li>
            <li><b>Testing and token economy properties analysing </b>(equilibrium of the token economy, the absence of undesirable scenarios, resistance to malicious actions, etc.)</li>
            <li><b>Prediction of the project scenarios for optimal stakeholders' actions</b></li>
          
          </ul>
          <div class="buttonsForSlide">
            <a href="https://tokenomics.expert/">START TO USE</a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 mt-3">
        <div class="services-box text-center hover-effect">
          <i class="pe-7s-display2 text-primary"></i>
          <h4 class="pt-3">SMART CONTRACT DEVELOPMENT SERVICE</h4>
          <ul class="pt-3 text-muted li_align">
            <li><b>Environment for Smart Contract development</b></li>
            <li><b>Detection of vulnerabilities and checking for resistance to cyber-attacks and malicious collusions</b></li>
            <li><b>Supporting the number of smart contract languages</b>, such as Solidity, Rust, TEAL, Anchor, and so on, <b>for different blockchain platforms</b></li>
          </ul>
          <p class="availSoon">WILL BE AVAILABLE SOON</p>
        </div>
      </div>
      <div class="col-lg-4 mt-3">
        <div class="services-box text-center hover-effect">
          <i class="pe-7s-news-paper text-primary"></i>
          <h4 class="pt-3">CRYPTOPROJECT MONITORING SERVICE</h4>
          <ul class="pt-3 text-muted li_align">
            <li>A <b>number of specialized neural networks for projects` token economy development predictions </b>and <b>confirmation of predicted scenarios by algebraic modelling</b></li>
            <li><b>Monitoring and making the right decisions according to project development predictions</b> based on current crypto market data</li>
            <li>Determination of a <b>plan of action in critical situations</b> and <b>plan further actions to obtain more profit</b></li>
          </ul>
          <p class="availSoon">WILL BE AVAILABLE SOON</p>
        </div>
      </div>
    </div>
  </div>
</section>
<!--START SERVICES-->
